var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"h4 m-t-0 m-b-2"},[_vm._v("Work Area")]),(_vm.locations.length)?_c('work-area',{attrs:{"locations":_vm.locations}}):_c('div',[_vm._v("No Work Area")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }